/**
 * src/components/ui/Table.jsx
 * Tabla responsiva con header sticky y estado vacío/loading.
 */

export function Table({ columns, data: rawData, onRowClick, loading, emptyMessage = 'Sin datos' }) {
  const data = Array.isArray(rawData) ? rawData : []
  return (
    <div style={{ overflowX: 'auto' }}>
      <table style={{
        width: '100%', borderCollapse: 'collapse',
        fontSize: '13px', fontFamily: 'var(--font-ui)',
      }}>
        <thead>
          <tr>
            {columns.map(col => (
              <th
                key={col.key}
                style={{
                  textAlign: col.align || 'left',
                  padding: '10px 14px',
                  fontSize: '11px', fontWeight: 500,
                  color: 'var(--color-text-3)', fontFamily: 'var(--font-mono)',
                  letterSpacing: '0.08em', textTransform: 'uppercase',
                  borderBottom: '1px solid var(--color-border)',
                  whiteSpace: 'nowrap',
                  width: col.width,
                }}
              >
                {col.label}
              </th>
            ))}
          </tr>
        </thead>
        <tbody>
          {loading ? (
            <tr>
              <td colSpan={columns.length} style={{ textAlign: 'center', padding: '40px', color: 'var(--color-text-3)' }}>
                <div style={{
                  display: 'inline-flex', alignItems: 'center', gap: '8px', fontSize: '12px',
                  fontFamily: 'var(--font-mono)',
                }}>
                  <span style={{
                    width: '14px', height: '14px', border: '2px solid var(--color-border)',
                    borderTopColor: 'var(--color-accent)', borderRadius: '50%',
                    animation: 'spin 0.7s linear infinite', display: 'inline-block',
                  }} />
                  Cargando...
                </div>
              </td>
            </tr>
          ) : data.length === 0 ? (
            <tr>
              <td colSpan={columns.length} style={{
                textAlign: 'center', padding: '40px',
                color: 'var(--color-text-3)', fontSize: '12px', fontFamily: 'var(--font-mono)',
              }}>
                {emptyMessage}
              </td>
            </tr>
          ) : (
            data.map((row, i) => (
              <tr
                key={row.id ?? i}
                onClick={() => onRowClick?.(row)}
                style={{
                  borderBottom: '1px solid var(--color-border)',
                  cursor: onRowClick ? 'pointer' : 'default',
                  transition: 'background 0.1s',
                }}
                onMouseEnter={e => { if (onRowClick) e.currentTarget.style.background = 'var(--color-surface-2)' }}
                onMouseLeave={e => { e.currentTarget.style.background = 'transparent' }}
              >
                {columns.map(col => (
                  <td
                    key={col.key}
                    style={{
                      padding: '11px 14px',
                      color: col.mono ? 'var(--color-text)' : 'var(--color-text)',
                      fontFamily: col.mono ? 'var(--font-mono)' : 'var(--font-ui)',
                      fontSize: col.mono ? '12px' : '13px',
                      textAlign: col.align || 'left',
                      whiteSpace: col.nowrap ? 'nowrap' : 'normal',
                    }}
                  >
                    {col.render ? col.render(row[col.key], row) : (row[col.key] ?? '—')}
                  </td>
                ))}
              </tr>
            ))
          )}
        </tbody>
      </table>
    </div>
  )
}
